import * as React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import type { ViewStyle } from "react-native";

import type { IconName } from "./AbstractIcon";
import _AbstractIcon from "./AbstractIcon";

export const AbstractIcon = _AbstractIcon;

type Props = {
  iconName: IconName;
  onPress?: () => void;
  color?: string;
  style?: ViewStyle;
};

export default function IconButton(props: Props) {
  const onPress = props.onPress || null;
  const color = props.color || "black";

  if (onPress != null) {
    return (
      <TouchableOpacity onPress={props.onPress}>
        <View style={styles.completionIcon}>
          <AbstractIcon name={props.iconName} size={24} color={color} />
        </View>
      </TouchableOpacity>
    );
  }

  return (
    <View style={styles.completionIcon}>
      <AbstractIcon name={props.iconName} size={24} color={color} />
    </View>
  );
}
const styles = StyleSheet.create({
  completionIcon: {
    flex: 1,
    height: 44,
    width: 44,
    alignItems: "center",
    justifyContent: "center",
  },
});
